import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=cb6a6dc0&scoped=true&"
import script from "./RoleManagement.vue?vue&type=script&lang=js&"
export * from "./RoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=cb6a6dc0&prod&lang=scss&scoped=true&"
import style1 from "./RoleManagement.vue?vue&type=style&index=1&id=cb6a6dc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6a6dc0",
  null
  
)

export default component.exports